export const COMPANY_TYPES = [{value: 'company', label: 'Company'}, {value: 'individual', label: 'Individual'}];

export function isAccountTypeCompany(accountType) {
    return accountType === COMPANY_TYPES[0].value;
}

export function isAccountTypeIndividual(accountType) {
    return accountType === COMPANY_TYPES[1].value;
}
